import { ServiceDetailPage } from './ServiceDetailPage';

export function AutomationServices() {
  return <ServiceDetailPage slug="automation" />;
}
